import { ResponseData, ResponseError, axiosInstance, Request } from '@/helpers'
const moduleName = 'binbase'
export const Check = ({bin}) =>{
  const req = Request();
  return axiosInstance.post(`/${moduleName}`,{bin}, req).then(ResponseData).catch(ResponseError)
}
export default {
  Check,
}